// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import { FormFieldLabel, FormInputWrapper } from "@west/MobiusOverrides/FormField";
import { color, mergeWithCss } from "@west/XDL/Utilities";
import capitalize from "lodash/capitalize";
import React, { FC, useState } from "react";
import { css } from "styled-components";

// XNG-Changes
interface OwnProps {
    formId?: string;
    extendedStyles?: TextFieldPresentationProps;
}

const qtyFieldStyle: TextFieldPresentationProps = {
    mergeCss: true,
    sizeVariant: "small",
    backgroundColor: "common.white",
    labelProps: {
        size: 10,
        weight: "normal",
        css: css`
            min-height: initial;
            position: absolute;
            z-index: 1;
            text-align: center;
            background: white;
            width: auto;
            left: 50%;
            transform: translateX(-50%);
            top: -5px;
            padding: 0 2px;
            line-height: 10px;
            white-space: nowrap;
        `,
    },
    cssOverrides: {
        formField: css`
            position: relative;
            max-width: 50px;

            ${/* sc-selector */ FormFieldLabel} + ${/* sc-selector */ FormInputWrapper} {
                margin-top: 0;
            }

            input:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                box-shadow: none;
                text-align: center;
                padding: 0;
                &.danger {
                    border-color: ${color("danger")};
                }
            }
        `,
    },
};
// XNG-Changes
type Props = OwnProps & TextFieldProps;

const QtyField: FC<Props> = props => {
    const [styles] = useState(() => mergeWithCss(qtyFieldStyle, props.extendedStyles));
    return (
        <TextField
            {...props}
            {...styles}
            label={typeof props.label === "string" ? capitalize(props.label || translate("Qty")) : props.label}
            type="qty"
            // XNG-Changes
            {...{ formId: props.formId }}
        />
    );
};

export default QtyField;
